import { CookieManagerService } from './cookie-manager.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { HttpClientService } from '..';
import { ApiEndpoints } from '../../core-modules/constant';

@Injectable()

export class CommonService {

	constructor(
		private httpClientService: HttpClientService,
		private cookieManagerService: CookieManagerService,

	  ) { }

	  getPartners(){

			return new Promise((resolve, reject) => {
				this.httpClientService.get(ApiEndpoints.getPartners).subscribe(response => {
					resolve(response.data);
				}, error => {
					reject();
				});
		});
  }

  getwijayanews(){

    return new Promise((resolve, reject) => {
      this.httpClientService.get(ApiEndpoints.getwijayanews).subscribe(response => {

        resolve(response);
      }, error => {

      });
  });
}




	isDialogMobileNumber(phoneNumber){
		var dialogRegex =  /^(077|076)\d{7}$/;
		var mobitelRegex =  /^(071|070|078|072)\d{7}$/;
			if (phoneNumber && dialogRegex.test(phoneNumber)) {
				return true;
			}
			else{
				return false;
			}
	}

	closePromoPopup(closePopup){


	}

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/common-service.ts